import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function getCallMetadata(requestObject) {
  validateUserKey(requestObject.userKey);
  try {
    const { data } = await apiClient.get("api/getCallMetadata", {
      params: requestObject,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
